import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Tag } from "antd5";
import classNames from "classnames";

import Spinner from "components/ui/spinner/Spinner";
import Tooltip from "components/ui/tooltip/Tooltip";
import { EllipsisTooltipText } from "lib/core_components/EllipsisTooltip";

import css from "./SelectedKeywordTags.module.scss";

type Props = {
  selectedKeywords: string[];
  isLoading: boolean;
  icon?: React.ReactNode;
  tooltipTitle?: string;
  tagClassname?: string;
  onChange: (keyword: string[]) => void;
  closeDropdown: () => void;
  // TODO: clean up when we decided to keep or remove signals icon
  // showIconForTag: (keyword: string) => boolean;
  showIcon: boolean;
};

export default function SelectedKeywordTags({
  selectedKeywords,
  isLoading,
  icon,
  tooltipTitle,
  tagClassname,
  onChange,
  closeDropdown,
  // showIconForTag,
  showIcon,
}: Props): JSX.Element | null {
  if (selectedKeywords.length === 0) {
    return null;
  }

  return (
    <div className={css.keywordSelections} aria-label="keywordSelections" onClick={closeDropdown}>
      <div className={css.tagContainer}>
        {selectedKeywords.sort().map((keyword: string) => {
          // const showIcon = showIconForTag(keyword);
          return (
            <Tooltip content={showIcon ? tooltipTitle : undefined} key={keyword} side="bottom">
              <Tag
                key={keyword}
                aria-label={`${keyword} tag`}
                className={classNames(css.tag, tagClassname)}
                closeIcon={<CloseOutlined />}
                onClose={() => onChange(selectedKeywords.filter((v: string) => v !== keyword))}
              >
                {isLoading ? (
                  <Spinner color="currentColor" />
                ) : (
                  <>
                    {showIcon && <>{icon}</>}
                    <EllipsisTooltipText
                      fullText={keyword}
                      textProps={{ className: css.tagLabel }}
                    />
                  </>
                )}
              </Tag>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
}
